<template>
  <button
    class="btn btn-light-primary mx-4"
    type="button"
    v-on:click="$router.go(-1)"
  >
    Back
  </button>
</template>

<script>
export default {
  name: "BackButton"
};
</script>
